import React, { useState, useContext } from "react";
import { useMutation } from "@apollo/react-hooks";
import _ from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import Typography from "@material-ui/core/Typography";
import { STATE_CULTURE } from "../Actions/stateActions";
import TopActions from "./topActions";
import BookingsList from "./bookingsList";
import Payment from "./payment";
import { AppContext, OPEN_TOAST } from "../Context";
import gql from "graphql-tag";
import { uriWithCulture } from "./util";

const PAY_BOOKING = gql`
  mutation initiatePayment {
    initiatePayment {
      uri
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  bookings: {
    // height: `${theme.height - 64}px`,
    paddingBottom: "1.5rem",
    "@media screen and (max-width: 600px)": {
      height: "100%",
    },
  },
  header: {
    background: theme.app.background[1],
    color: theme.app.labelColor,
    padding: "0 16px",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gridGap: "16px",
    alignItems: "center",
    borderBottom: `1px solid ${theme.app.borderColor}`,
    height: "80px",
    "@media(max-width: 600px)": {
      height: "60px",
    },
  },
  heading: {
    fontSize: "1.35rem",
    fontWeight: 500,
  },
  photo: {
    height: "40px",
    width: "40px",
    borderRadius: "50%",
  },
  actions: {
    height: "60px",
    background: theme.app.background[1],
    borderTop: `1px solid ${theme.app.borderColor}`,
    alignItems: "center",
    gridTemplateColumns: "1fr auto",
    // gridGap: "16px",
    padding: "0 16px",
    display: "none",
    "@media screen and (max-width: 768px)": {
      position: "fixed",
      display: "grid",
      bottom: "3.5rem",
      width: "100%",
    },
  },
}));

const Bookings = (props) => {
  const { mybookings } = props;
  const classes = useStyles();
  const context = useContext(AppContext);
  const { dispatch } = context;
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [selected, setSelected] = useState();
  const { language, culture, checkoutEnabled } = useSelector((state) => ({
    language: state.language,
    culture: state.cookies[STATE_CULTURE],
    checkoutEnabled: state.config.checkoutEnabled,
  }));
  const handleMutationSuccess = (data) => 
    (window.location = uriWithCulture(data.initiatePayment.uri, culture));
    
  const handleMutationError = (error) =>
    dispatch({ type: OPEN_TOAST, toastText: error, toastType: "error" });
  const [initiatePayment, { loading }] = useMutation(PAY_BOOKING, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess,
  });

  if (!mybookings) return <div />;
  const locale = culture.substring(0, 2).toLowerCase();
  const anyUnpaid =
    mybookings &&
    mybookings.filter((b) => b.isConfirmed && !b.isPaid).length > 0;
  const confirmedBookings =
    mybookings && mybookings.filter((b) => b.isConfirmed);
  const cancelledBookings =
    mybookings && mybookings.filter((b) => b.isCancelled);
  const filterCancelledBookings =
    mybookings && mybookings.filter((el) => !el.isCancelled);
  const queuedBookings =
    mybookings &&
    filterCancelledBookings &&
    filterCancelledBookings.filter((el) => !el.isCancelled) &&
    filterCancelledBookings.filter((b) => b.isQueue);
  const payableBookings =
    mybookings && mybookings.filter((b) => b.isConfirmed && !b.isPaid);
  const nextPayment = _.chain(payableBookings)
    .filter((x) => x.lastPaymentTime)
    .map((x) => moment(x.lastPaymentTime))
    .sort()
    .min()
    .value();
  const getSelected = () => {
    if (selected === "confirmed") return confirmedBookings;
    if (selected === "queued") return queuedBookings;
    if (selected === "cancelled") return cancelledBookings;
    return [];
  };

  return (
    <>
      <main className={classes.bookings}>
        <div className={classes.header}>
          <Typography className={classes.heading} variant="h1">
            {language.my_bookings}
          </Typography>
        </div>
        <TopActions
          anyConfirmed={confirmedBookings.length > 0}
          anyCancelled={cancelledBookings.length > 0}
          anyQueued={queuedBookings.length > 0}
          selected={selected}
          setSelected={setSelected}
          language={language}
          bookings={mybookings}
        />
        <BookingsList
          bookings={getSelected()}
          anyUnpaid={anyUnpaid}
          next={nextPayment}
          locale={locale}
          language={language}
          mybookings={mybookings}
          checkoutEnabled={checkoutEnabled}
          selected={selected}
          culture={culture}
        />

        {anyUnpaid && (
          <div className={classes.actions}>
            {checkoutEnabled && (
              <Button
                color="violet.9"
                varianti="filled"
                radius="sm"
                size="md"
                onClick={initiatePayment}
              >
                {language.pay}
              </Button>
            )}
          </div>
        )}
      </main>
      <Payment
        open={paymentOpen}
        handleClose={() => setPaymentOpen(false)}
        language={language}
        culture={culture}
      />
    </>
  );
};

export default Bookings;
